import React, { useEffect, useState } from "react";
import { Typography, Avatar, Tooltip } from "antd";
import { getProffesionalName, getShortProffesionalName } from "../util/helpers";
import { useIntl } from "react-intl";
const { Text } = Typography;

const ProffesionalEmployee = (props) => {
  const { record, withAvatar, long } = props;
  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");

  const intl = useIntl();
  const letter =
    record && record["first_name"] ? record["first_name"].charAt(0) : "";

  useEffect(() => {
    if (record) {
      setName(getProffesionalName(record, intl));
      setShortName(getShortProffesionalName(record, intl));
    }
  }, [intl, record]);
  return (
    <Tooltip title={name}>
      <div>
        {withAvatar ? (
          record["avatar_url"] ? (
            <Avatar src={record["avatar_url"]} />
          ) : (
            <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
              {letter}
            </Avatar>
          )
        ) : null}
        <Text style={{ padding: withAvatar ? "0 10px" : "0 0" }}>
          {long ? name : shortName}
        </Text>
      </div>
    </Tooltip>
  );
};

export default ProffesionalEmployee;
